import { render, staticRenderFns } from "./CtaRibbonModule.vue?vue&type=template&id=59be76d1&"
import script from "./CtaRibbonModule.ts?vue&type=script&lang=ts&"
export * from "./CtaRibbonModule.ts?vue&type=script&lang=ts&"
import style0 from "./CtaRibbonModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports